
import { useEffect, useState } from 'react';
// import './css/zendesk.css';
// import './css/quilityIcons.css'
import './../css/zendesk.css'
import './../css/quilityIcons.css'
import { getZe } from '../utilities/initZendesk';

function ZendeskLauncher() {

    const zE = getZe()

    const [isOpen, setIsOpen] = useState(false)
    const [unreadMessages, setUnreadMessages] = useState(0)

    const handleClick = () => {
        if (isOpen) {
            zE('messenger', 'close')
            setIsOpen(false)
        } else {
            zE('messenger', 'open')
            setIsOpen(true)
        }
    }

    useEffect(() => {
        zE('messenger', 'close')

        zE('messenger:on', 'open', () => {
            setIsOpen(true)
            setUnreadMessages(0)
		})

        zE('messenger:on', 'close', () => {
			setIsOpen(false)
		})
    }, [])

    return (
            <button className='q-zendesk-launcher' onClick={_ => handleClick()}>
                <div className={`q-zendesk-launcher__badge${unreadMessages === 0 ? ' opacity-0' : '' }`}>
                    {unreadMessages}
                </div>

                <div className={isOpen ? 'q-arrow-down' : 'q-zendesk-support-image'} style={{backgroundRepeat: 'no-repeat', backgroundSize: 20, width: 24, height:24, margin: '12px 8px' }}></div>
            </button>
    )
}

export default ZendeskLauncher